// extracted by mini-css-extract-plugin
export var aircallIframe = "_mw-3";
export var fabContainer = "_mw-5";
export var fabRinging = "_mw-6";
export var loadingOverlay = "_mw-4";
export var pulse = "_mw-7";
export var widgetContent = "_mw-2";
export var widgetPanel = "_mw-0";
export var widgetPanelExpanded = "_mw-1";